import React, { useState } from 'react';
import styled from 'styled-components';
import Link from '@mui/material/Link';
import { CardGiftModel } from '@dobredary-pl/card-config';
import CardFilledView from '../card-filled-view/CardFilledView';

const CardContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;

  & .gatsby-image-wrapper {
    &:hover {
      cursor: pointer;
      box-shadow: 2px 2px 10px 2px gray;
    }
  }
  & a {
    cursor: pointer;
  }
`;

const CardPreview = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000;
  border-radius: 100%;
  box-sizing: border-box;
  position: absolute;
  right: 1rem;
  bottom: 1rem;
  height: 140px;
  width: 140px;
  padding: 1rem;
  opacity: 0.85;
  pointer-events: none;

  @media only screen and (max-width: 480px) {
      height: 125px;
      width: 125px;
  }

  a {
    display: flex;
    align-items: center;
    color: #fff;
    font-size: 17px;
    font-weight: bold;
    text-decoration: none;

    @media only screen and (max-width: 480px) {
      font-size: 14px;
    }
  }
`;

interface CardImagePreviewProps {
  cardData?: CardGiftModel;
  handleSelectCard?: () => void;
}

const CardImagePreview = ({
  cardData,
  handleSelectCard,
  ...imageProps
}: CardImagePreviewProps) => {
  const [previewOpen, setPreviewOpen] = useState(false);

  return (
    <CardContainer onClick={() => setPreviewOpen(!previewOpen)}>
      <CardFilledView card={cardData}></CardFilledView>
      <CardPreview><Link>{previewOpen ? 'Zobacz przód kartki' : 'Zobacz tył kartki'} →</Link></CardPreview>
    </CardContainer>
  );
};

export default CardImagePreview;
